<template>
    <modal
        :title="title"
        :id="id"
        :actionButtons="true"
        :size="'full'"
        @shown="shown"
        @hidden="hidden"
    >
        <div class="card d-md-none">
            <div class="ml-4">
                <ul class="nav nav-tabs nav-overflow">
                    <tabs
                        :tabs="tabs"
                        v-model="tab">
                    </tabs>
                </ul>
            </div>
        </div>

        <div class="row mt-0">
            <div class="col-12 col-md-7 col-lg-8 fullHeight">
                <div class="card d-md-block" v-show="tab === 'MAP'">
                    <div class="card-body pt-0 m-0">
                        <div class="row mt-3">
                            <div class="col"></div>
                            <div class="col-auto">
                                <custom-switch v-model="kid" :title="$t('Baby map') " id="kidOrNot2" class="m-0 p-0" />
                            </div>
                        </div>

                        <image-map :kid="kid" :selectable="true" v-model="selected" :width="15" :tooths="{}"></image-map>

                        <div class="row mt-2 mb-0">
                            <div class="col">
                                <custom-switch
                                    v-if="selected.length>1"
                                    v-model="grouped"
                                    id="grouped"
                                    :title="$t('Grouped')"
                                ></custom-switch>
                            </div>
                            <div class="col-auto">
                                <button
                                    v-if="selected.length<1"
                                    disabled
                                    class="btn btn-outline-info btn-sm"
                                >{{ $t('Teeth not selected') }}
                                </button>
                                <button class="btn btn-outline-info btn-sm" @click="selected=[]" v-else>
                                    <i class="fe fe-x"/>
                                    {{ $t('Clear selection') }}
                                    <span
                                        class="small"
                                    >({{ selected.length }})</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <preset-treatment-browser class="d-md-block calcHeight col-12" v-show="tab === 'SERVICES'" :use-preset="usePreset" :use-treatment="addToCart"></preset-treatment-browser>
            </div>
            <div v-show="tab === 'TOTAL'" class="col-12 col-md-5 col-lg-4 d-md-block">
                <div class="relative d-flex flex-md-column flex-column-reverse">
                    <div class="sticky-top fit-tablet">
                        <div class="card mb-2" v-if="cart.length == 0">
                            <div class="card-body text-center text-muted small">
                                <div class="h1 mt-0 p-2 fe fe-shopping-cart"></div>
                                {{ $t('Nothing yet') }}
                            </div>
                        </div>
                        <div class="card mb-2" v-for="(cartItem, index) in cart" :key="index">
                            <div class="card-body p-2">
                                <div class="row align-items-center">
                                    <div class="col small">
                                        {{ cartItem.item.label }}
                                        <div>
                                            <money :value="(cartItem.item.price || 0)*cartItem.quantity" class="small text-muted"/>
                                        </div>
                                    </div>
                                    <div class="col-auto p-0 small">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <button class="btn btn-white btn-sm" @click="changeCartQuantity(index, -1)">-</button>
                                            <button class="btn btn-white btn-sm">{{ cartItem.quantity }}</button>
                                            <button class="btn btn-white btn-sm" @click="changeCartQuantity(index, 1)">+</button>
                                        </div>
                                    </div>

                                    <div class="col-auto small">
                                        <button
                                            class="btn btn-white btn-sm"
                                            :id="`service-${cartItem._id}`"
                                            :title="$t('Select tooth')"
                                            v-b-tooltip.hover
                                        >{{ cartItem.tooths.length }}
                                        </button>
                                        <tooth-popover v-model="cartItem.tooths" :target="'service-' + cartItem._id" :isKid="kid" />
                                        <button class="btn btn-white btn-sm border-0" @click="removeFromCart(index)">
                                            <i class="fe fe-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-header">
            <span></span>
        </template>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col" style="position: initial;">
                    </div>
                    <div class="col-auto"></div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="mr-2 btn btn-white">Отмена</button>
                        <button type="button" @click="confirmed" class="btn btn-primary">{{ $t('Save') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import ImageMap from '@/components/Teeth/Map';
import CustomSwitch from '@/components/CustomSwitch';
import ToothPopover from '@/components/Tooth/ToothPopover';
import SpecialtyNav from '@/components/SpecialtyNav';
import Tabs from '@/components/Tabs';
import {mapActions} from "vuex";
import {modalMixins} from "@/mixins/modal.js";
import PresetTreatmentBrowser from "@/components/PresetTreatmentBrowser";

export default {
    name: "AddTreatmentModal",
    props: {
        id: String,
        emitResults: Function,
        stage: {
            type: Number,
            default: 1,
        },
        tooth: {
            type: Number,
            default: 0,
        },
    },
    mixins: [modalMixins],
    components: {
        PresetTreatmentBrowser,
        Modal,
        Money,
        ImageMap,
        SpecialtyNav,
        CustomSwitch,
        ToothPopover,
        Tabs,
    },
    data() {
        return {
            tab: 'MAP',
            tabs: [
                {
                    text: this.$t('Map'),
                    value: 'MAP',
                },
                {
                    text: this.$t('Services'),
                    value: 'SERVICES',
                },
                {
                    text: this.$t('Total'),
                    value: 'TOTAL',
                },
            ],
            finished: false,
            exams: [],
            cart: [],
            grouped: false,
            selected: [],
            title: this.$t("Add treatment"),
            kid: false,
        };
    },

    methods: {
        ...mapActions('presets', { fetchPresets: 'find' }),

        shown() {
            this.fetchPresets(this.presetParams);
            this.selected = this.tooth ? [this.tooth] : []
        },

        hidden() {
            this.cart = []
            this.selected=[]
        },

        usePreset(preset) {
            preset.treatments.forEach(cart => {
                this.addToCart(cart);
            })
        },

        addToCart(item) {
            let quantity = 1;
            if (!this.grouped && this.selected.length > 1) {
                quantity = this.selected.length;
            }
            let _id = item._id;
            let tooths = this.$unique(this.selected);

            let index = this.cart.findIndex(i => {
                return _id == i._id;
            });
            let price = item.price;

            if (index >= 0) {
                this.cart[index].quantity += quantity;
                this.cart[index].tooths = this.$unique(this.cart[index].tooths, ...tooths);
            } else {
                this.cart.push({ _id, item, quantity, tooths, price, grouped: this.grouped });
            }
        },

        removeFromCart(idx) {
            this.cart.splice(idx, 1);
        },

        changeCartQuantity(idx, quantity) {
            this.cart[idx].quantity = this.cart[idx].quantity + quantity;
            if (this.cart[idx].quantity <= 0) {
                this.removeFromCart(idx);
            }
        },

        confirmed() {
            let results = [];
            this.cart.forEach(cart => {
                const treatment = { ...cart.item };
                if (cart.tooths.length) {
                    cart.tooths.forEach(tooth => {
                        results.push({tooth: tooth, stage: this.stage, treatment: treatment});
                    })
                } else {
                    results.push({tooth: null, stage: this.stage, treatment: treatment});
                }
            });
            this.emitResults(results);
            this.$root.$emit("bv::hide::modal", this.id);
        },

        validation(field) {
            if (this.errors && this.errors[field]) return false;
            else return null;
        },

        close() {
            this.$root.$emit("bv::hide::modal", this.id);
        },
    }
};
</script>

<style lang="scss">
</style>
